import React, { useContext, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Constants from 'expo-constants';
import PropTypes from 'prop-types';
import CdnImageBackground from '../common/CdnImageBackground';
import { H3, H5 } from '../text';
import LayoutContext from '../../contexts/Layout';
import AppConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import AppContext, { AppActions } from '../../contexts/App';
import useFeaturedService from '../../hooks/useFeaturedService';
import useVCmsContent from '../../hooks/useVCmsContent';
import Button from '../common/Button';
import ComponentTitle from '../common/ComponentTitle';

const FeaturedService = ({ enableImageOverlay = false, heading, nodeTypeAlias = 'FeaturedService', speaker, width }) => {
    const { dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const featuredService = useFeaturedService(false, speaker);
    const [imageDimensions, setImageDimensions] = useState();
    const service = useVCmsContent(featuredService?.haivisionPublicId);

    const watch = async () => {
        const response = await window.fetch(`${Constants.manifest.extra.baseUrl}${AppConstants.REACT_APP_PAGE_BASE}${AppConstants.REACT_APP_INTERNAL_REDIRECT_FEATURED}`);
        const json = await response.json();

        if (json) {
            dispatch({
                type: AppActions.WATCH_FEATURED_SERVICE,
                data: {
                    page: json.page,
                    service
                }
            });
        }
    };

    if (!service) {
        return null;
    }

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator }}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
        >
            {!!heading && <ComponentTitle title={heading} />}
            <CdnImageBackground
                enableOverlay={enableImageOverlay}
                imageDimensions={imageDimensions}
                setImageDimensions={setImageDimensions}
                uri={service.thumbnailUrl}
                width={width}
            >
                <View
                    style={StyleSheet.flatten(Styles.contentContainer, { marginHorizontal: layout.styleGuide.spacer2 })}
                    dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerRight: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                >
                    <View style={StyleSheet.flatten(Styles.detailsContainer, { bottom: !layout.device.isMobile ? layout.styleGuide.spacer2 : undefined })}>
                        <View style={{ flex: 1 }}>
                            <H3
                                style={{ color: service.textColor || '#fff', marginBottom: layout.styleGuide.spacer4 }}
                                text={service.title || 'Featured Service'}
                                dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                            />
                            <H5
                                style={Styles.detailsContainer.description}
                                text={`${featuredService.speaker || speaker} | ${Utils.formatDateTimeShow30MinOrNot(service.viewDateTime)}`}
                            />
                        </View>
                        <Button onPress={watch} text={service.buttonText || 'Watch Now'} />
                    </View>
                </View>
            </CdnImageBackground>
        </View>
    );
};

const Styles = StyleSheet.create({
    contentContainer: {
        backgroundColor: 'transparent',
        flex: 2,
        justifyContent: 'flex-end'
    },
    detailsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        description: {
            color: 'white',
            fontFamily: 'GothamBook'
        }
    }
});

FeaturedService.propTypes = {
    enableImageOverlay: PropTypes.bool,
    heading: PropTypes.string,
    speaker: PropTypes.string
};

export default FeaturedService;
